export default {
    groups: {
        action: "Acción",
        actionOptions: "Opciones de acción",
        actionType: "Tipos de acción",
        availChannelsUplink: "Canales de Subida Disponibles / Estaciones Base",
        availChannelsUplinkOnly: "Canales de Subida Disponibles",
        availChannelsDownlink: "Canales de Bajada Disponibles / Estaciones Base",
        id: "ID",
        rules: 'Reglas',
        createRule: "Crear regla",
        updateRule: "Actualizar regla",
        deleteRule: 'Eliminar regla seleccionada',
        type: "Escribe",
        groups: "Grupos",
        ruleConfig: "Configuración de reglas",
        ruleGroupResults: "Resultados del grupo",
        group: "Grupo",
        groupDetails: 'Detalles del grupo',
        groupName: 'Nombre del grupo',
        ruleName: 'Nombre de la regla',
        ruleInfo: 'Información de la regla',
        ruleSuite: 'Colocar de reglas',
        sortGrouping: 'Ordenar etiqueta',
        ruleGroup: 'Grupo de reglas',
        membershipRules: "Criterios de membresía",
        modificationDate: "Fecha de modificación",
        modificationUser: "Usuario",
        order: 'Orden',
        totalRadios: 'Radios totales',
        radiosMovingUp: 'Subiendo',
        nextStartTimeTitle: 'Siguiente ejecución de ajuste completo:',
        radiosAlreadyConfigured: 'Total {totalCount} Ya configurada',
        matchedMembershipCriteria: 'Criterios de afiliación coincidentes de {totalCount} totales', 
        radiosPerfIncreasing: 'Aumento del rendimiento',
        radiosMovingDown: 'Bajando',
        radiosPerfDecreasing: 'Disminución del rendimiento',
        radiosMovingIn: 'Mudándose',
        radiosMovingOut: 'Mudarse',
        radiosMovingInTotal: "Total Entrando",
        radiosMovingInMPass: "Entrando mPass",
        groupItemsContainerTitle: 'Elementos de grupo',
        deleteGroupPrompt: '¿Estás segura de que quieres eliminar el grupo "{ruleName}"?',
        deleteSetPrompt: '¿Está seguro de que desea eliminar el conjunto "{setName}"?',
        groupSuccess: 'Éxito del grupo {actionType}',
        groupFailed: '{actionType} grupo falló',
        targetConfiguration: "Configuración de destino",
        enableAction: "Activar acción",
        disableAction: "Deshabilitar acción",
        actionEnabled: "Acción habilitada",
        ruleEnabled: "Regla Habilitada",
        enableRule: "Activar Regla",
        disableRule: "Deshabilitar Regla",
        ruleType: "Tipo de regla",
        description: "Descripción",
        ruleDescription: "Descripción de la regla",
        executionOrder: 'Orden de ejecución',
        enableActionSuccess: "Acción habilitada con éxito",
        disableActionSuccess: "Acción deshabilitada con éxito",
        updateActionFail: "Error de acción de actualización",
        ruleNameRequired: "Nombre de regla obligatorio",
        ruleTypeRequired: "Nombre de compañera obligatorio",
        executionOrderMin: "No puede estar en negativa",
        executionOrderMax: "La orden de ejecución máxima permitida es 999",
        executionOrderReq: "Se requiere orden de ejecución",
        membership: "Afiliación",
        requiredMembership: 'Membresía requerida',
        additionalMembership: 'Membresía adicional',
        orderedRulesExcludeNote: 'Las reglas ordenadas excluyen las radios de sintonizar o sintonizan radios estableciendo una nueva configuración. Solo se aplica la primera regla de coincidencia.',
        matchAction: "Radios ya configuradas para este grupo",
        matchMembership: "Criterios de membresía coincidentes, dirigido a este grupo",
        groupAverageLatencyHours: 'Horas de latencia promedio',
        groupAverageTransmitRate: 'Velocidad de transmisión promedio (% del total directo, repetido)',
        groupPercentTransmitDirectRadios: 'Directo - Tasa de transmisión promedio (% del total directo, repetido)',
        groupPercentDirectRadiosReadSuccess: 'Directo - Rendimiento de lectura (directo, repetido)',
        groupPercentTransmitBuddiedRadios: 'Compañeros - Tasa de transmisión promedio (% del total directo, repetido)',
        groupPercentBuddiedRadiosReadSuccess: "Amigo - Rendimiento de lectura (directo, repetido)",
        groupPercentTransmitCombined: "Tasa Promedio de Transmisión\n(% Directo/% Enlazado)",
        groupPercentCombinedReadSuccess: "Rendimiento de Lectura\n(% Directo/% Enlazado)",
        ruleTypes: {
            tuning: 'Afinación',
            nonTuning: 'Sin afinación',
            specialConditionRule: 'Condición especial',
            placeholder: 'marcador de posición'
        },
        actionTypes: {
            NONE: "Ninguna",
            NCO_PING_SIMPLE_SETUP: "Silbido",
            NCO_SETUP: "Configurar",
        },
        radioTypes: {
            RADIOS_NON_TUNING: "Radios sin sintonización",
            RADIOS_TUNING: "Sintonización de radios",
            RADIOS_SPECIAL_CONDITION: "Condición especial de radios",
            RADIOS_PLACEHOLDER: 'marcador de posición',
            RADIOS_BUDDY_SB: "Retransmisor de Estática",
            RADIOS_BUDDY_SOS: "Compañera SOS",
            RADIOS_BUDDY_VITAL: "Compañera de Vital"
        },
        doNotChange: "No cambies",
        enable: "Activada",
        disable: "Discapacitada",
        sosBuddy: "compañera SOS",
        staticRebroadcaster: "Retransmisor de Estática",
        vitalBuddy: "Compañera de Vital",
        buddyConfigChangeStartTime: "Hora de Inicio Del Cambio de Configuración de Compañera",
        buddyConfigChangeCount: "Configuración de Compañera de Radio Modificada",
        vitalBuddyConfigChangeId: "Identificación de Compañera de Vital",
        sosBuddyConfigChangeId: "Identificación de Compañera de SOS",
        staticRebroadcasterBuddyConfigChangeId: "Identificación de Compañera de Transmisor Estático",
        configVitalBuddy: "Configurar Compañera de Vital",
        configSOSBuddy: "Configurar compañera SOS",
        configSBBuddy: "Configurar Retransmisor de Estática",
        configBuddy: "Configurar Compañera",
        updateFailed: "Error al actualizar la regla",
        createFailed: "No se pudo crear la regla",
        requiredMemberFailed:"No se pudo crear la regla \'{name}\' El filtro de membresía requerido no debe estar vacío",
        additionalMemberFailed:"No se pudo crear la regla \'{name}\' Se debe agregar al menos un criterio de membresía",
        deleteFailed: "No se pudo borrar la regla",
        enableActionFailed: "No se pudo habilitar la acción",
        disableActionFailed: "No se pudo inhabilitar la acción",
        autoOptPerf: "Optimización automática del rendimiento",
        deleteSuccess: "Regla eliminada ",
        fetchRulesListFailed: "No se pudo obtener la lista de reglas",
        exeOrderToolTip: "Dejar vacío para las reglas de condiciones especiales; de lo contrario, establecer el orden de ejecución de las reglas",
        ruleInvalidCombination: "El tipo de una regla debe ser una condición especial de radios si el orden de ejecución de las reglas está vacío",
        ruleAlreadyExist: "La regla ya existe",
        importedRuleAlreadyExists: 'Ya existen una o más reglas en el conjunto de reglas al que se está importando',
        executionOrderLimitExceeded: "Se alcanzó el límite máximo de la orden de ejecución",
        executionOrderPositive: "Un grupo de ajuste debe tener un número de orden de ejecución >= 1",
        ruleCreated: "Regla creada ",
        ruleUpdated: "Regla actualizó ",
        cannotBeLowerThanMin: "El mínimo no puede exceder el máximo",
        cannotBeNegative: "El valor debe ser no negativo",
        ruleSets: 'Conjunto de reglas',
        createRuleSet: 'Crear nuevo conjunto de reglas',
        createRuleSetCopy: 'Crear copia del conjunto de reglas actual',
        createRuleSetFromSelected: 'Crear nuevo conjunto de reglas a partir de reglas seleccionadas',
        deleteRuleSet: 'Eliminar conjunto de reglas actual',
        setTuningRuleSet: 'Establecer como conjunto de reglas de ajuste activo',
        makeRuleSetInactive: 'Hacer conjunto de reglas inactivo',
        setActiveInactiveError: 'Error al configurar como activo/inactivo',
        setAlreadyActiveError: "Error al configurar como activo. Otro conjunto de reglas ya está configurado como el trabajo de ajuste activo y primero debe desactivarse",
        updateRuleSet: 'Editar conjunto de reglas',
        ruleSetLastModified: "Última modificación el {modDate} por {user}",
        activeJob: 'Activo: ',
        inactiveJob: 'Inactivo',
        readOnly: 'Solo lectura',
        createRuleSetError: 'Error en la creación del conjunto de reglas',
        deleteRuleSetError: 'Falló la eliminación del conjunto de reglas',
        deleteActiveRuleSetError: 'Antes de eliminar este conjunto de reglas, debe configurarlo como Inactivo.',
        createCopyOfRuleSetError: 'Falló la copia del conjunto de reglas',
        invalidRuleSetNameError: 'Los nombres de los conjuntos de reglas no deben estar vacíos ni contener caracteres no válidos',
        setName: 'Nombre del conjunto de reglas',
        importRuleSet: 'Importar conjunto de reglas desde un archivo JSON',
        exportRuleSet: 'Exportar conjunto de reglas a archivo JSON',
        import: 'Importar',
        ruleSet: "Conjunto de reglas",
        runs : "Carreras",
        results: "Resultados",
        invalidJsonFile: "Error al importar el conjunto de reglas. El archivo no es JSON válido.",
        importRuleSetError: "Error al importar el conjunto de reglas; El formato difiere del esperado",
        selectRuleSet: "Seleccionar conjunto de reglas existente",
        copyRuleToExisting: "Duplicar reglas a conjunto de reglas existente",
        copyRuleToCurrent: "Duplicar regla al conjunto de reglas actual",
        copyRuleToExistingError: "Error al duplicar reglas al conjunto existente.",
        copyRuleToCurrentError: "Error al duplicar la regla al conjunto actual.",
        ruleCreatedWithExecutionOrder: "{name} creada con orden de ejecucion {executionOrder}",
        ruleCreatedNoExecutionOrder: "{name} creada",
        duplicateSuffix: ' - duplicada',
        radioConfigTuningNonTuning: 'Reglas de sintonización y no sintonización',
        radioConfigTuning: 'Reglas de sintonización',
        radioConfigNonTuning: 'Reglas de no sintonización',
        radioConfigSpecialCondition: 'Reglas de condiciones especiales',
        ruleSetActions: {
            CREATE_NEW: 'Crear nuevo conjunto de reglas',
            CREATE_COPY: "Crear copia del conjunto de reglas actual",
            CREATE_COPY_FROM_SELECTED: "Crear nuevo conjunto de reglas a partir de reglas seleccionadas",
            UPDATE: "Editar conjunto de reglas"
        },
        noFiltersActive: 'No hay filtros activos',
        filtersActive: 'Filtros activos',
        tempHints: {
            matchMembership: "La cantidad de puntos finales seleccionados para este grupo porque sus estadísticas de rendimiento coincidieron con los criterios de membresía de esta regla.",
            matchAction: "La cantidad de puntos finales actualmente configurados para este grupo porque su configuración ya coincide con la configuración que establecería la acción de regla de este grupo.",
        },
        radioLimit: 'Límite de radio',
        initialMessage: 'Seleccione el archivo JSON para cargar',
        beginningImport: 'Comenzando la importación del archivo.',
        ruleSetImported: 'Conjunto de reglas importado exitosamente',
        ruleSetExists: 'Ya existe un conjunto de reglas con este nombre.',
        ruleSetJSON: 'Conjunto de reglas JSON File',
        specialCharCheckFailed: 'El nombre debe constar de caracteres alfanuméricos, guiones, espacios, paréntesis y guiones bajos',
        jsonInvalid: 'JSON no es válido. Consulte los errores a continuación.'
    }
}
